export enum PriceChangeEnum {
    AlwaysAsk,
    AcceptHigherOdds,
    AcceptAnyOdds,
    CounterOffer,
};

export const PriceChangeViewEnum = {
    [PriceChangeEnum.AlwaysAsk]: 'Always ask',
    [PriceChangeEnum.AcceptHigherOdds]: 'Accept higher odds',
    [PriceChangeEnum.AcceptAnyOdds]: 'Accept any odds',
};

